import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, ArrowRight } from "lucide-react";
import { LOGO_MAIN } from "@/data/content";

const WA_NUMBER = "40740433894";
const DEFAULT_MSG = "Salut DOTAPAN! Sunt interesat de produsele voastre pentru afacerea mea HoReCa.";

export default function WhatsAppFloat() {
  const [shown, setShown] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setShown(true), 700);
    return () => clearTimeout(t);
  }, []);

  // Lock body scroll when modal open
  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    else document.body.style.overflow = "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(DEFAULT_MSG)}`;

  const goToWhatsApp = () => {
    window.open(href, "_blank", "noopener,noreferrer");
    setTimeout(() => setOpen(false), 300);
  };

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        data-testid="whatsapp-float"
        aria-label="Vorbește cu noi pe WhatsApp"
        className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
          shown ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
        }`}
      >
        <div className="relative">
          <span className="pulse-ring" />
          <div className="relative h-14 w-14 md:h-16 md:w-16 rounded-full bg-[#25d366] text-white flex items-center justify-center shadow-[0_15px_40px_-10px_rgba(37,211,102,0.6)] hover:scale-110 transition-transform">
            <MessageCircle className="h-6 w-6 md:h-7 md:w-7" />
          </div>
        </div>
      </button>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="whatsapp-modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.25 }}
            className="fixed inset-0 z-[60] flex items-center justify-center px-4"
          >
            <div
              className="absolute inset-0 bg-black/70 backdrop-blur-sm"
              onClick={() => setOpen(false)}
              data-testid="whatsapp-modal-overlay"
            />
            <motion.div
              initial={{ opacity: 0, y: 30, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.97 }}
              transition={{ duration: 0.35, ease: [0.22, 0.72, 0.21, 1] }}
              className="relative w-full max-w-md rounded-3xl overflow-hidden bg-[#0b0b0f] border border-gold/30 shadow-[0_30px_80px_-20px_rgba(217,164,65,0.4)]"
            >
              <button
                onClick={() => setOpen(false)}
                aria-label="Închide"
                data-testid="whatsapp-modal-close"
                className="absolute top-3 right-3 z-10 h-9 w-9 rounded-full bg-black/60 border border-white/15 flex items-center justify-center text-white hover:bg-black/80 transition-colors"
              >
                <X className="h-4 w-4" />
              </button>

              <div className="relative h-40 flex items-center justify-center bg-gradient-to-br from-[#1a1208] via-[#0b0b0f] to-[#0a1f0e] border-b border-white/10 overflow-hidden">
                <div className="absolute inset-0 grain opacity-50" />
                <img src={LOGO_MAIN} alt="DOTAPAN" className="relative h-24 object-contain" />
              </div>

              <div className="p-6 md:p-8 text-center">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-[#25d366]/15 border border-[#25d366]/40 text-[#25d366] text-[10px] uppercase tracking-[0.25em]">
                  <MessageCircle className="h-3 w-3" />
                  WhatsApp DOTAPAN
                </div>
                <h3 className="font-display text-2xl md:text-3xl text-white mt-4">
                  Hai să vorbim despre <em className="text-gold not-italic">meniul tău.</em>
                </h3>
                <p className="mt-3 text-sm text-white/75 leading-relaxed">
                  Răspundem rapid pe WhatsApp pentru oferte, mostre și recomandări de produse pentru afacerea ta HoReCa.
                </p>
                <p className="mt-4 text-xs uppercase tracking-[0.25em] text-gold">+40 740 433 894</p>

                <button
                  onClick={goToWhatsApp}
                  data-testid="whatsapp-modal-continue"
                  className="mt-6 inline-flex items-center justify-center gap-2 w-full h-12 rounded-full bg-[#25d366] text-white font-semibold text-sm shadow-[0_15px_40px_-10px_rgba(37,211,102,0.6)] hover:brightness-110 hover:-translate-y-0.5 transition-all"
                >
                  Continuă pe WhatsApp <ArrowRight className="h-4 w-4" />
                </button>
                <button
                  onClick={() => setOpen(false)}
                  className="mt-3 text-[11px] uppercase tracking-[0.2em] text-white/50 hover:text-white/80"
                >
                  Mai târziu
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
